import Head from 'next/head';

export default function Terms() {
  return (
    <div className="max-h-[100vh]">
      <Head>
        <title>Terms - StartScreen</title>
        <meta property="og:title" content="StartScreen" />
        <meta
          property="og:description"
          content="The next-generation employee training platform."
        />
      </Head>
      <div class="aliased relative py-16 bg-gradient-to-b from-[#12132d] via-[#000212] to-[#000212] overflow-hidden min-h-screen">
        <div
          data-aos="fade-up"
          class="relative px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto"
        >
          <div class="text-lg max-w-prose mx-auto">
            <h1>
              <span class="block text-base text-center text-white font-semibold tracking-wide uppercase">
                As of Nov 15 2022
              </span>
              <span class="mt-3 block text-center lg:text-4xl text-3xl font-extrabold mb-6 text-white tracking-tight">
                Terms of Use
              </span>
            </h1>
          </div>
          <div class="mt-12 prose prose-blue prose-lg text-white mx-auto space-y-4 bg-[#272A3F] bg-opacity-50 rounded-md p-6">
            <p>
              <span className="font-semibold">1. Introduction</span> <br />
              By using startscreen.io you confirm your acceptance of, and agree
              to be bound by, these term and conditions.{' '}
            </p>
            <p>
              <span className="font-semibold">
                2. Agreement to Terms and Conditions
              </span>{' '}
              <br />
              This Agreement takes effect on the date on which you first use the
              startscreen.io application.{' '}
            </p>

            <p>
              <span className="font-semibold"> 3. Product Usage</span> <br />
              By using startscreen.io, you agree to receive important product
              updates from startscreen.io via the email linked with your account
              or the email you used to register your account. You can opt-out of
              product updates anytime by clicking to the "Unsubscribe" link at
              the bottom of each email. We only send important product updates.
            </p>
            <p>
              <span className="font-semibold">4. Disclaimer</span> <br />
              It is not warranted that startscreen.io will meet your
              requirements or that its operation will be uninterrupted or error
              free. All express and implied warranties or conditions not stated
              in this Agreement (including without limitation, loss of profits,
              loss or corruption of data, business interruption or loss of
              contracts), so far as such exclusion or disclaimer is permitted
              under the applicable law are excluded and expressly disclaimed.
              This Agreement does not affect your statutory rights.{' '}
            </p>
            <p>
              <span className="font-semibold">
                5. Warranties and Limitation of Liability
              </span>{' '}
              <br />
              startscreen.io does not give any warranty, guarantee or other term
              as to the quality, fitness for purpose or otherwise of the
              software. startscreen.io shall not be liable to you by reason of
              any representation (unless fraudulent), or any implied warranty,
              condition or other term, or any duty at common law, for any loss
              of profit or any indirect, special or consequential loss, damage,
              costs, expenses or other claims (whether caused by
              startscreen.io's negligence or the negligence of its servants or
              agents or otherwise) which arise out of or in connection with the
              provision of any goods or services by startscreen.io.
              startscreen.io shall not be liable or deemed to be in breach of
              contract by reason of any delay in performing, or failure to
              perform, any of its obligations if the delay or failure was due to
              any cause beyond its reasonable control. Notwithstanding contrary
              clauses in this Agreement, in the event thatstartscreen.io are
              deemed liable to you for breach of this Agreement, you agree that
              startscreen.io's liability is limited to the amount actually paid
              by you for your services or software, which amount calculated in
              reliance upon this clause. You hereby release startscreen.io from
              any and all obligations, liabilities and claims in excess of this
              limitation.{' '}
            </p>
            <p>
              <span className="font-semibold">6. General Terms and Law</span>{' '}
              <br />
              This Agreement is governed by the laws of Ontario, Canada. You
              acknowledge that no joint venture, partnership, employment, or
              agency relationship exists between you and startscreen.io as a
              result of your use of these services. You agree not to hold
              yourself out as a representative, agent or employee of
              startscreen.io. You agree that startscreen.io will not be liable
              by reason of any representation, act or omission to act by you.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
